import { render, staticRenderFns } from "./LicenseHolderWidget.vue?vue&type=template&id=033a6296&lang=pug"
import script from "./LicenseHolderWidget.vue?vue&type=script&lang=js"
export * from "./LicenseHolderWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports